import { useState, useEffect } from 'react'

interface PriceData {
  currentPrice: string
  comparePrice: string
  isLoading: boolean
}

const PRICE_MAP: Record<string, { current: string; compare: string }> = {
  US: { current: '$14.90', compare: '$34.90' },
  EC: { current: '$14.90', compare: '$34.90' },
  MX: { current: '$327.12 MXN', compare: '$750.00 MXN' },
  CA: { current: '$23.10 CAD', compare: '$49.00 CAD' },
  CL: { current: '$17.216 CLP', compare: '$38.500 CLP' },
  CO: { current: '$57.667 COP', compare: '$125.000 COP' },
  PE: { current: 'S/ 55.00', compare: 'S/ 120.00' },
  UY: { current: '$637.00 UYU', compare: '$1.450 UYU' },
  PY: { current: 'Gs. 101.459', compare: 'Gs. 230.000' },
  BO: { current: 'Bs 109.00', compare: 'Bs 240.00' },
  AR: { current: 'ARS\xA0$14.990', compare: 'ARS\xA0$30.990' },
}

const DEFAULT_PRICES = PRICE_MAP.AR

let cachedCountry: string | null = null

export function useGeoPricing(): PriceData {
  const [prices, setPrices] = useState<{ current: string; compare: string }>(
    DEFAULT_PRICES,
  )
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    if (cachedCountry) {
      setPrices(PRICE_MAP[cachedCountry] || DEFAULT_PRICES)
      setIsLoading(false)
      return
    }

    const detectCountry = async () => {
      try {
        const response = await fetch('https://ipapi.co/json/', {
          signal: AbortSignal.timeout(5000),
        })
        const data = await response.json()
        const countryCode = data.country_code?.toUpperCase() || ''
        cachedCountry = countryCode
        setPrices(PRICE_MAP[countryCode] || DEFAULT_PRICES)
      } catch {
        setPrices(DEFAULT_PRICES)
      } finally {
        setIsLoading(false)
      }
    }

    detectCountry()
  }, [])

  return {
    currentPrice: prices.current,
    comparePrice: prices.compare,
    isLoading,
  }
}
